'use strict';

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

const jsxRuntime = require('react/jsx-runtime');
const React = require('react');
const components_display_TooltipWrapper_TooltipWrapper = require('../TooltipWrapper/TooltipWrapper.cjs.js');

const avatarGroup = "_avatar-group_1lt12_1";
const count = "_count_1lt12_21";
const styles = {
	avatarGroup: avatarGroup,
	count: count
};

const AvatarGroup = ({ children, size = void 0, max = 3, overflowCopy }) => {
  const childrenArray = React.Children.toArray(children).filter(Boolean);
  const slicedChildren = childrenArray.slice(0, max);
  const remainingChildren = childrenArray.length - slicedChildren.length;
  const overflowTooltip = React.useMemo(() => overflowCopy || `Plus ${remainingChildren} others`, [overflowCopy, remainingChildren]);
  const content = size !== "large" ? jsxRuntime.jsx("div", { className: styles.count, "data-zds": true, children: overflowCopy || `${Math.min(remainingChildren, 999)} others` }) : jsxRuntime.jsx(components_display_TooltipWrapper_TooltipWrapper.TooltipWrapper, { content: overflowTooltip, position: "southeast", children: () => jsxRuntime.jsx("div", { "aria-label": overflowTooltip, className: styles.count, "data-zds": true, children: Math.min(remainingChildren, 999) }) });
  return jsxRuntime.jsxs("div", { className: styles.avatarGroup, "data-size": size, "data-zds": true, children: [slicedChildren, remainingChildren > 0 && content] });
};

exports.AvatarGroup = AvatarGroup;
//# sourceMappingURL=AvatarGroup.cjs.js.map
